/**
 * Medic pouch. Straps across whatever is already being worn, so it takes an accessory slot rather
 * than the torso.
 */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { ArmorItem } from '@/sim/items/itemContract';

export const MEDIC_POUCH = {
  id: 'medicPouch',
  kind: 'armor',
  label: 'Medic pouch',
  description: 'Canvas, red cross, mostly empty. Whoever packed it was an optimist.',
  rarity: 'uncommon',
  weightKg: 0.8,
  stackLimit: 1,
  equip: {
    slots: ['accessory1', 'accessory2', 'accessory3'],
    statDeltas: { endurance: 1 },
    armor: NO_ARMOR,
    damageModifiers: [],
  },
} as const satisfies ArmorItem;
